var map = {
	"./ffdinwebpro-medium.eot": 20,
	"./ffdinwebpro-medium.ttf": 21,
	"./ffdinwebpro-medium.woff": 22,
	"./ffdinwebpro-medium.woff2": 23,
	"./ffdinwebpro-regular.eot": 24,
	"./ffdinwebpro-regular.ttf": 25,
	"./ffdinwebpro-regular.woff": 26,
	"./ffdinwebpro-regular.woff2": 27,
	"./nexaslab-black.eot": 28,
	"./nexaslab-black.ttf": 29,
	"./nexaslab-black.woff": 30,
	"./nexaslab-black.woff2": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;